import Link from 'next/link'

import ServiceNavigationMenu from './pageBuilderBlocks/ServiceNavigationMenu'
import FeaturedDeals from './pageBuilderBlocks/FeaturedDeals'
import SectionDivider from './pageBuilderBlocks/SectionDivider'
import LatestNews from './pageBuilderBlocks/LatestNews'
import InsightsGrid from './pageBuilderBlocks/InsightsGrid'
import ServiceNavigationList from './pageBuilderBlocks/ServiceNavigationList'
import Image from './pageBuilderBlocks/Image'
import SectionHeader from './pageBuilderBlocks/SectionHeader'
import TwoColumnText from './pageBuilderBlocks/TwoColumnText'
import SingleMedia from './pageBuilderBlocks/SingleMedia'
import CollapsibleList from './pageBuilderBlocks/CollapsibleList'
import Slideshow from './pageBuilderBlocks/Slideshow'
import Quote from './pageBuilderBlocks/Quote'
import TextBody from './pageBuilderBlocks/TextBody'
import LockUpBasic from './pageBuilderBlocks/LockUpBasic'

interface ArticleContentProps {
	contentBlocks: Array<any>
}

const ArticleContent = (props: ArticleContentProps) => {

	const { contentBlocks } = props

	if (!contentBlocks || contentBlocks.length === 0) {
		return null
	}

	return (
		<>
			{contentBlocks.map((block: any) => {

				switch (block.typeHandle) {
					case 'textBody':

						return <TextBody key={block.id} block={block} />

					case 'sectionDivider':

						return <SectionDivider key={block.id} />

					case 'featuredDeals':

						return <FeaturedDeals key={block.id} block={block} />

					case 'latestNews':

						// TODO - Check implementation. Add heading and link as own props
						return <LatestNews key={block.id} {...block} />

					case 'insights':

						return <InsightsGrid key={block.id} block={block} />

					case 'singleMedia':

						return <SingleMedia
							key={block.id}
							media={block.media?.length > 0 ? block.media[0] : null}
							caption={block.caption}
							size={'insight'}
						/>

					case 'serviceNavigationList':

						return <ServiceNavigationList key={block.id} block={block} />

					case 'sectionHeader':

						return <SectionHeader key={block.id} block={block} />

					case 'twoColumnText':

						return <TwoColumnText key={block.id} block={block} />

					case 'collapsibleList':

						return <CollapsibleList key={block.id} block={block} />

					case 'slideshow':

						return <Slideshow key={block.id} block={block} />

					case 'quote':

						return <Quote key={block.id} block={block} />

					case 'lockUp':

						return <LockUpBasic key={block.id} block={block} />

					default:
						return null
				}

			})}
		</>
	)
}
export default ArticleContent
